import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges
} from '@angular/core';
import { Subscription } from 'rxjs';
import { IDmsConfig } from '../../interface/document.manager.interface';
import { DocumentManagerService } from '../../services/document-manager.service';

@Component({
    selector: 'app-document-information',
    templateUrl: './document-information.component.html',
    styleUrls: ['./document-information.component.scss']
})
export class DocumentInformationComponent implements OnInit, OnDestroy, OnChanges {
    @Output() CloseEvent = new EventEmitter();
    @Input() SelectedDocument;
    @Input() dmsConfig: IDmsConfig;
    public Document = {
        Name: ''
    };
    public SelectedTab: string = 'Details'; // 'Details' | 'Activity'

    Content: any = null;
    onShowSubscription: Subscription;
    public Actions = {
        CloseSideNav: () => {
            this.CloseEvent.emit();
        },
        SelectDetailsTab: () => {
            this.SelectedTab = 'Details';
        },
        SelectActivityTab: () => {
            this.SelectedTab = 'Activity';
        }
    };

    constructor(private documentManagerService: DocumentManagerService) {}

    ngOnInit() {
        this.onShowSubscription = this.documentManagerService.onShowDetail.subscribe(Content => {
            this.Content = Content;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        const _SelectedDocument: SimpleChange = changes.SelectedDocument;
        if (_SelectedDocument.currentValue) {
            this.Document = _SelectedDocument.currentValue;
        }
    }

    ngOnDestroy() {
        if(this.onShowSubscription)this.onShowSubscription.unsubscribe();
    }
}

// interface IRolesMap {
//     Value: string,
//     ViewValue: string,
// }
// interface IDmsConfig {
//     RowBreakPoint?: Object;
//     ExtMap?: Object;
//     detailsTab?: {
//         isShowRoles?: boolean;
//         isShowPersons?: boolean;
//         rolesList?: IRolesMap[];
//     }
// }
